import React from 'react';
import { useTranslation } from 'react-i18next';
import { DesignStatus } from 'src/enums/design-status';
import styles from './Message.module.css';

interface messageProps {
    designStatus: DesignStatus;
    id?: string;
}

export function Message(props: messageProps) {
    const { designStatus, id } = props;
    const { t } = useTranslation();
    let icon = '';
    let message = '';
    if (designStatus === DesignStatus.Approved) {
        icon = styles.approve;
        message = t('SharedDesignActionDone.Title.Approved');
    } else {
        icon = styles.return;
        message = t('SharedDesignActionDone.Title.Returned');
    }

    return (
        <div auto-id={id} data-testid={id} className={styles.container}>
            <image className={`${styles.image} ${icon}`} />
            <div className={styles.message}>
                <div className={styles.title}>{message}</div>
                <div>{t('SharedDesignActionDone.Message.ContactLab')}</div>
            </div>
        </div>
    );
}
